import { BarcodeQuestionConfig } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { ControlledCheckboxItem } from '../../../../../components/forms';
import { Colors } from '../../../../../themes/colors';
import {
  RoutineQuestionAdminForm,
  RoutineQuestionAdminFormProps,
} from '../types';

export const BarcodeQuestionAdminForm: RoutineQuestionAdminForm<
  BarcodeQuestionConfig
> = (props: RoutineQuestionAdminFormProps<BarcodeQuestionConfig>) => {
  const { t } = useTranslation();
  const prefix = props.indexPrefix ? `${props.indexPrefix}.` : '';
  const allowMultipleFieldName = `${prefix}allowMultiple`;
  const includeQuantityFieldName = `${prefix}includeQuantity`;

  props.control.register(allowMultipleFieldName, {
    value: props.config.allowMultiple ?? false,
  });
  props.control.register(includeQuantityFieldName, {
    value: props.config.includeQuantity ?? false,
  });

  return (
    <>
      <ControlledCheckboxItem
        control={props.control}
        name={allowMultipleFieldName}
        label={t('routines.workflow.admin.question.barcodeScanner.allowMultiple')}
        position="trailing"
        style={styles.container}
        labelStyle={styles.label}
      />
      <ControlledCheckboxItem
        control={props.control}
        name={includeQuantityFieldName}
        label={t('routines.workflow.admin.question.barcodeScanner.includeQuantity')}
        position="trailing"
        style={styles.container}
        labelStyle={styles.label}
      />
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 0,
  },
  label: {
    fontSize: 16,
    lineHeight: 16,
    color: Colors.black,
    marginBottom: 10,
    fontWeight: '700',
  },
});
